import { RowData, Table } from '@tanstack/table-core';
import React from 'react';

import TableHeader from './Header';
import { styThead } from './style';

function TableHead<TDataModel extends RowData>({ table }: { table: Table<TDataModel> }) {
  return (
    <thead className={styThead}>
      {table.getHeaderGroups().map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <TableHeader<TDataModel> key={header.id} header={header} />
          ))}
        </tr>
      ))}
    </thead>
  );
}

export default TableHead;
